import styled, { css } from "styled-components";
import { Modal } from "antd";
import { PrimaryButtonComponent, GhostButtonComponent,PillButton } from "../../../../CommonComponents/commonStyles";
import {  SaveLink } from "../../styles";

const styles = css`
font-family: HelveticaNeue-Medium;
font-size: 16px;
color: #006778;
`;

export const DeleteAccess = styled.a`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.primaryColor};
  text-decoration: underline;
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
`;

export const CancelButton = styled(GhostButtonComponent)`
  margin-right: 20px;
  @media(max-width: 576px){
    font-size: ${props => props.theme.fontSize.primary} !important;
  }
`;

export const UpdateButton = styled(PrimaryButtonComponent)`
  @media(max-width: 576px){
    font-size: ${props => props.theme.fontSize.primary} !important;
  }
`;

export const DeleteModal = styled(Modal)`
  &&& {
    .ant-modal-content {
      border-radius: 0px;
      text-align:center;
    }
    .ant-modal-header {
      padding: 15px 30px 15px 30px;
      background: #fff; 
      border-radius: unset;
      @media (max-width: 576px) {
        padding: 10px 15px;
      }
    }
    .ant-modal-title {
      text-align: center;
      font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
      font-size: ${props => props.theme.fontSize.h4};
      font-weight: ${props => props.theme.fontWeight.normal};
      line-height: ${props => props.theme.lineHeight.h4};
      color: ${props => props.theme.fontColors.headingColor};
    }
    .ant-modal-footer {
      padding: 16px 20px;
      display: flex;
      justify-content: center;
      border-top: 1px solid #dddddd;
      border-radius: 0 0 4px 4px;
    }
  }
`;

export const AddBody = styled.div`
  margin:62px 0px 50px 0px;
`;

export const InlineLinkTo = styled(SaveLink)`
  display:inline-block;
`;

export const AddPillAccount = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 227px;
  height: 30px;  
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size: ${props => props.theme.fontSize.secondary};
  background-color: ${props => props.theme.backgroundColor.pill};
  color: ${props => props.theme.fontColors.primary};
  border: solid 1px ${props => props.theme.border.pill};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.secondary};
  border-radius: 1rem;
  span {
    padding-left: 0.25rem;
    padding-top: 8px;
    span{
      font-size: ${props => props.theme.fontSize.h5};
      display: inline-block;
      height: 30px;
      padding: 0;
    }
  }
  &:hover {
    color: ${props => props.theme.fontColors.primary};
  }

  @media only screen and (max-width: 991.92px) {
    align-self: center;
    margin-left: 0;
  }
`;




export const AddAdvisorLinkButton = styled.div`
  margin-top: 30px !important;
  @media only screen and (max-width: 991px) {
    margin-top: 20px !important;
  }
`;

export const PillButtonAddd = styled(PillButton)`
  ${styles}
  margin: 16px 20px 0px 0;
  &:hover,
  &:focus {
    color: #006778;
    background: #f5f5f5;
    border-color: #d9d9d9;
  }
`;
